import { Flex } from "antd";
import styled from "styled-components";

export const FlexWrap = styled(Flex)`
  width: 100%;
`

export const CreateCodesWrap = styled(Flex)<{ color: string }>`
  width: 100%;

  & .code-input--wrap {
    border: 1px solid ${({color}) => color};
    border-radius: 4px;
    padding: 6px 10px;
  }
`
